<template>
  <div>
    <v-row justify="center">
      <vue-svg-gauge
        class="miniGauge"
        :start-angle="-90"
        :end-angle="90"
        :value="this.percentage"
        :separatorStep="2"
        :separatorThickness="1"
        :scaleStep="1"
        :scaleInterval="1"
        :min="0"
        :max="100"
        :gauge-color="this.color"
        :base-color="$vuetify.theme.dark ? '#484848' : '#dddddd'"
        :scale-interval="1"
        :innerRadius="75"
      >
        <div style="display: flex; justify-content: center; align-items: center; height: 150%">
          {{ Math.round(this.value2 * 10) / 10 }}
          <template v-if="this.showEnergy"> kWh </template>
          <template v-else> % </template>
          <br />
          {{ this.value }} kW
        </div>
      </vue-svg-gauge>
    </v-row>

    <v-row class="text-subtitle-1" dense>
      <v-col align="center" cols="1" md="2" lg="3" xl="4">
        <b>0</b>
      </v-col>
      <v-col align="center" cols="10" md="8" lg="6" xl="4">
        <b>kW </b>
      </v-col>
      <v-col align="center" cols="1" md="2" lg="3" xl="4">
        <b>{{ this.max }}</b>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "ChargerGauge",
  components: {},
  props: {
    showEnergy: {
      type: Boolean,
      default: false,
      require: true,
    },
    max: {
      type: Number,
      default: 0,
      require: true,
    },
    value: {
      type: Number,
      default: 0,
      require: true,
    },
    value2: {
      type: Number,
      default: 0,
      require: true,
    },
    percentage: {
      type: Number,
      default: 0,
      require: true,
    },
    color: {
      type: Array,
      require: true,
    },
  },
};
</script>

<style scoped>
.miniGauge {
  max-height: 250px;
  max-width: 480px;
}
</style>
